import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';
import { WMS1100_R01DetailDto, WMS1100_R01Dto, WMS1100_R01HeaderDto, WMS1100_R01LotDto } from "./Dto_WMS1100_R01";
import { WMS1100_R01Filter } from "./Store_WMS1100_R01";
import { WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";


const baseUrl = `${config.apiUrl}/WMS1100_R01`;

const getParams = (filter: Partial<WMS1100_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,	

		listLength: listLength || 0
	}
}

export const getWMS1100_R01List = async (option: string, params: Partial<WMS1100_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<WMS1100_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getWMS1100_R01AllCount = async (params: Partial<WMS1100_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getWMS1100_R01DetailList = async (transportCode: string) => {
	const url = `${baseUrl}/detail/${transportCode}`;

	return await getData<ResponseDto<WMS1100_R01DetailDto[]>>(url);
}

export const getWMS1100_R01LotList = async (transportNo: string, itemCd: string) => {
	const url = `${baseUrl}/lot`;

	return await getData<ResponseDto<WMS1100_R01LotDto[]>>(url, { params: { 
			transportNo : transportNo || undefined,
			itemCd : itemCd || undefined,
		} 
	});
}

export const downloadExcel_WMS1100_R01 = async (option: string, transportNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			transportNo
		}
	})
}